// @flow
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { Link } from 'react-router-dom';
import MultiImage from '../../../../elements/MultiImage/MultiImage';
import { FormattedMessage, intlShape } from 'react-intl';
import { stateConverter, saleThreeStateConverter } from '../../../order/utils/stateConverter';
import { getLocalizedCountry } from '../../../local-values/utils/countries';

import style from './OrderBox.scss';
import type { Flight, Order } from '../../../../entities';
import type {
  StateConvertResponse,
  SaleInnerThreeState,
} from '../../../order/utils/stateConverter';
import type { LocalValuesState } from '../../../local-values/duck';

type Props = {
  +localValues?: LocalValuesState;
  +order: Order;
  +flight: Flight;
  +type: 'available' | 'sale';
};

export default class OrderBox extends Component<Props> {
  render() {
    const { localValues, order, flight, type } = this.props;
    let link = `/flight/${flight.id}/order/${order.id}/reserve`;
    if (type === 'sale') link = `/sale/order/${order.id}`;

    const stateResponse: StateConvertResponse = stateConverter(true, order.state);
    const saleStateResponse: SaleInnerThreeState = saleThreeStateConverter(order.state);
    return (
      <Fragment>
        <Link to={link}
              className={style.orderBox}>
          <article className={style.wrapper}>
            <section className={style.imageWrap}>
              <MultiImage items={order.items}/>
            </section>
            <section className={style.rightWrapper}>
              {type === 'available' ?
                <section className={style.orderInfo}>
                  <section className={style.quantityWrap}>
                    <FormattedMessage id="flight.orderBox.productsQuantity">{
                      txt => <p className={style.quantityText}>{txt}:</p>
                    }</FormattedMessage>
                    <p className={style.quantity}>{order.items.length}</p>
                  </section>
                  <section className={style.value}>
                    <FormattedMessage id="flight.orderBox.orderValue">{
                      txt => <p>{txt}:</p>
                    }</FormattedMessage>
                    <p>${order.invoice.detail.subtotal}</p>
                  </section>
                </section> :
                <section className={classNames(style.orderInfo, style.sale)}>
                  <section className={style.value}>
                    <p className={classNames(style.id, style.sale)}>{order.id}</p>
                    <FormattedMessage id="flight.orderBox.toCharge">{
                      txt => <p className={style.sale}>{txt}: {order.travelerTotal}</p>
                    }</FormattedMessage>
                    <FormattedMessage id="flight.orderBox.products">{
                      txt => <p className={style.sale}>{txt}: {order.items.length}</p>
                    }</FormattedMessage>
                  </section>
                </section>}
              {type === 'available' ?
                <section className={style.rightContent}>
                  <FormattedMessage id="flight.orderBox.commission">{
                    txt => <p>{txt}</p>
                  }</FormattedMessage>
                  <p className={style.commission}>${order.invoice.detail.commission}</p>
                </section> :
                <section className={style.rightContent}>
                  {order.deliveryCountry && localValues &&
                  <FormattedMessage id={stateResponse.labelIntlShort}>{
                    txt => stateResponse.innerState === '4s' ?
                      (<p className={style.sale}>
                        {`${txt} ${getLocalizedCountry(order.deliveryCountry.code,
                          this.context.intl.formatMessage, localValues.countriesMap)}`}</p>) :
                      (<p className={style.sale}>{txt}</p>)
                  }</FormattedMessage>}
                  <section className={style.tracking}>
                    <div className={classNames(style.step,
                      { [style.active]: ['1s', '2s', '3s'].includes(saleStateResponse) })}/>
                    <div className={classNames(style.step, style.center,
                      { [style.active]: ['2s', '3s'].includes(saleStateResponse) })}/>
                    <div className={classNames(style.step,
                      { [style.active]: saleStateResponse === '3s' })}/>
                  </section>
                </section>}
            </section>
          </article>
        </Link>
      </Fragment>);
  }
}

OrderBox.propTypes = {
  localValues: PropTypes.object,
  order: PropTypes.object.isRequired,
  flight: PropTypes.object.isRequired,
  type: PropTypes.string.isRequired,
};

OrderBox.contextTypes = {
  intl: intlShape,
};



// WEBPACK FOOTER //
// ./src/modules/flight/components/OrderBox/OrderBox.jsx